import Vue from "vue";
import "../../components/Tools/typdefs";

const state = {
  /** @type {StoredAnswers} */
  surveyInstances: {},
};

/** @type {import("vuex").GetterTree<typeof state,any>} */
const getters = {
  getSurveyAnswerbyId: (state) => (id) => {
    let key = id.toString();
    return state.surveyInstances[key];
  },
};

/** @type {import("vuex").ActionTree<typeof state>} */
const actions = {
  syncSurvey({ commit, state }, payload) {
    commit("addSurveyInstance", payload);
  },
  syncAnswers({ commit, state }, { id, data }) {
    let key = id.toString();
    let questionsNames = Object.keys(data);
    if (key in state.surveyInstances) {
      questionsNames.forEach((qname) => {
        const payload = { key, qname, value: data[qname] };
        commit("changeQuestion", payload);
      });
    } else {
      const payload = { id: key, data };
      commit("addSurveyInstance", payload);
    }
  },
  clearAllAnswers({ state }) {
    state.surveyInstances = {};
  },
};

/** @type {import("vuex").MutationTree<typeof state>} */
const mutations = {
  addSurveyInstance(state, { id, data }) {
    Vue.set(state.surveyInstances, id, data);
  },
  changeQuestion(state, { key, qname, value }) {
    Vue.set(state.surveyInstances[key], qname, value);
  },
};

export default {
  state,
  getters,
  actions,
  mutations,
};



// WEBPACK FOOTER //
// ./src/surveyjs/store/modules/surveyStore.js